/**
 * /devhub/tasks — Task queue (operator). Surface Layer (/01). REQ-001.91 DevHub UI rebuild · Phase 3.
 * Live operator panel (DevHubTaskQueuePanel) wired to its useDevHub* hook over GET /api/control/registry/:name.
 * Operator-only (routePolicy plane guard + DevHubPanelPage self-guard).
 */
import { createFileRoute } from '@tanstack/react-router';
import { DevHubTaskQueuePanel } from '../features/control-plane/DevHubTaskQueuePanel';
import { DevHubPanelPage } from '../components/devhub/DevHubPanelPage';

export const Route = createFileRoute('/devhub/tasks')({ component: TasksPage });

function TasksPage() {
  return (
    <DevHubPanelPage
      title="Task queue"
      subtitle="Local-AI orchestrator tasks; row opens a detail with send-to-AI analyze."
      status={{ label: 'live', live: true }}
    >
      <DevHubTaskQueuePanel />
    </DevHubPanelPage>
  );
}
